import { connect } from 'react-redux';

import LicenseDashboard from '../components/LicenseDashboard';
import {
  onLicenseQueryInputChange,
  loadLicenseEmployeeOptions,
  initLoadLicenseEmployeeOptionsActionStatus,
  loadLicenseInfo,
  initLoadLicenseInfoActionStatus,
  selectLicenseInfo,
  openAddOrEditLicenseModal,
  addOrEditLicenseChangeInput,
  addOrEditLicense,
  initAddOrEditLicenseActionStatus,
  resetAddOrEditLicenseModal,
  openDelLicenseModal,
  delLicense,
  initDelLicenseActionStatus,
  resetDelLicenseModal,
  loadLicenseNote,
  initLoadLicenseNoteActionStatus,
  licenseNoteChangeInput,
  addOrEditLicenseNote,
  initAddOrEditLicenseNoteActionStatus,
  resetLicenseNoteModal,
} from '../LicenseActions';

import { doOperationRecordAction } from '../../../common/operationRcd/OperationRecordActions';

const mapStateToProps = state => {
  return {
    employeeOptions: state.license.employeeOptions,
    licenseQueryFields: state.license.licenseQueryFields,
    loadLicenseEmployeeOptionsActionStatus: state.license.loadLicenseEmployeeOptionsActionStatus,
    loadLicenseInfoActionStatus: state.license.loadLicenseInfoActionStatus,
    loadLicenseInfoResp: state.license.loadLicenseInfoResp,
    selectedLicenseInfoArray: state.license.selectedLicenseInfoArray,
    addOrEditLicenseModal: state.license.addOrEditLicenseModal,
    addOrEditLicenseActionStatus: state.license.addOrEditLicenseActionStatus,
    delLicenseModal: state.license.delLicenseModal,
    delLicenseActionStatus: state.license.delLicenseActionStatus,
    licenseNoteModal: state.license.licenseNoteModal,
    loadLicenseNoteActionStatus: state.license.loadLicenseNoteActionStatus,
    addOrEditLicenseNoteActionStatus: state.license.addOrEditLicenseNoteActionStatus,
    operationRecord: state.operationRecord,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLicenseQueryInputChange: params => dispatch(onLicenseQueryInputChange(params)),
    loadLicenseEmployeeOptions: namePart => dispatch(loadLicenseEmployeeOptions(namePart)),
    initLoadLicenseEmployeeOptionsActionStatus: () => dispatch(initLoadLicenseEmployeeOptionsActionStatus()),
    loadLicenseInfo: params => dispatch(loadLicenseInfo(params)),
    initLoadLicenseInfoActionStatus: () => dispatch(initLoadLicenseInfoActionStatus()),
    selectLicenseInfo: array => dispatch(selectLicenseInfo(array)),
    openAddOrEditLicenseModal: (mode, data) => dispatch(openAddOrEditLicenseModal(mode, data)),
    addOrEditLicenseChangeInput: params => dispatch(addOrEditLicenseChangeInput(params)),
    addOrEditLicense: params => dispatch(addOrEditLicense(params)),
    initAddOrEditLicenseActionStatus: () => dispatch(initAddOrEditLicenseActionStatus()),
    resetAddOrEditLicenseModal: () => dispatch(resetAddOrEditLicenseModal()),
    openDelLicenseModal: data => dispatch(openDelLicenseModal(data)),
    delLicense: params => dispatch(delLicense(params)),
    initDelLicenseActionStatus: () => dispatch(initDelLicenseActionStatus()),
    resetDelLicenseModal: () => dispatch(resetDelLicenseModal()),
    loadLicenseNote: () => dispatch(loadLicenseNote()),
    initLoadLicenseNoteActionStatus: () => dispatch(initLoadLicenseNoteActionStatus()),
    licenseNoteChangeInput: params => dispatch(licenseNoteChangeInput(params)),
    addOrEditLicenseNote: params => dispatch(addOrEditLicenseNote(params)),
    initAddOrEditLicenseNoteActionStatus: () => dispatch(initAddOrEditLicenseNoteActionStatus()),
    resetLicenseNoteModal: () => dispatch(resetLicenseNoteModal()),
    doOperationRecordAction: params => dispatch(doOperationRecordAction(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LicenseDashboard);
